<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>【重要】サーバーメンテンナンスによるサービス停止・復旧のお知らせ</h3>
      <br>

      <p>お客様各位</p>

  <p>
    平素は、株式会社スカンジナビアサービスをご利用いただき、
    誠にありがとうございます。
  </p>

  <p>
    2026年10月21日(水) 22時頃より、
    システムメンテナンス（PHP脆弱性対応）により、
    ホームページが閲覧できない事象が発生しておりましたが、
    現在は復旧し、通常通りご利用いただける状態となっております。
  </p>

  <p>
    ご利用いただいております皆様には、
    多大なるご迷惑とご心配をお掛けしましたことを、
    深くお詫び申し上げます。
  </p>


      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news251226',
  props: {
    largescreen: {
      type: Boolean
    }
  },
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>